import {Box, ResponsiveContext} from "grommet";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { fetchApplicationInfo } from "@Api/applicationInfo";
import { ApplicationInfo } from "@Api/applicationInfoTypes";
import messages from "@Components/Login/messages";
import {useIntl} from "react-intl";

interface Props {}

const FooterBox = styled(Box)`
  max-width: 100%;
  min-width: 100%;
  font-size: 14px;  
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: darkgrey;
  z-index: 1;
  & a {
    color: #03316B;
    text-decoration: none;
    cursor: pointer;
    font-family: Roboto, sans-serif;
    font-weight: 400;
    font-size: 12px;
  }
  & a:hover {
    text-decoration: underline;
  }
  
  & div:last-child {
    color: #525252;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
  }
`;

const Footer: React.FC<Props> = () => {
  const size = React.useContext(ResponsiveContext);
  const paddingLeft = ("xsmall" === size || "small" === size) ? "0" : "100px";
  const { formatMessage } = useIntl();
  const [appInfo, setAppInfo] = useState({
    version: "",
    testMode: false,
  });


  useEffect(() => {
    fetchApplicationInfo().then((result: ApplicationInfo) =>
      setAppInfo(result)
    );
  }, []);

  return <FooterBox pad={{ left: paddingLeft }}>
    <div><a href="accessibility-report" target={'_blank'} rel="noopener noreferrer">{formatMessage(messages.accessibilityReport)}</a></div>
    <div>{formatMessage(messages.version) + ' ' + appInfo.version || ""}</div>
  </FooterBox>;
};

export default Footer;
